import type { ProposalExtraItemType } from '@econtractor/types';
import * as apiObject from 'api/apiObjects';

export const isProposalExtraAsOtherExpense = (
    item: Pick<ProposalExtraItemType, 'asOtherExpense'> | null | undefined,
): boolean => Boolean(item?.asOtherExpense);

export type AddProposalExtraAsOtherExpendParams = {
    objectId: number;
    itemName: string;
    itemCount: number;
    price: number;
    priceRate?: number;
    priceSale?: number;
    priceSaleRate?: number;
    teamId?: number;
    serviceId?: number;
    description?: string;
};

/** Додає позицію КП як послугу вкладки «Інше». */
export const addProposalExtraAsOtherExpend = async ({
    objectId,
    itemName,
    itemCount,
    price,
    priceRate,
    priceSale,
    priceSaleRate,
    teamId,
    serviceId,
    description,
}: AddProposalExtraAsOtherExpendParams): Promise<boolean> => {
    const count = Number(itemCount) || 0;
    if (!(objectId > 0) || !(count > 0)) return false;

    return apiObject.addExpendTeam({
        teamId: Number(teamId) || 0,
        objectId,
        serviceId: Number(serviceId) || 0,
        name: String(itemName || '').trim(),
        count,
        price: Number(price) || 0,
        priceRate,
        priceSale: Number(priceSale) || 0,
        priceSaleRate,
        description: description || '',
        isOther: true,
    });
};
